module.exports = __webpack_public_path__ + "static/media/placeholder.adef7f28.svg";